export const ROW_ACTIONS_MENU_LABELS = {
	DELETE_SESSION: 'Delete session',
	DELETE_TEST: 'Delete test'
} as const;
